import React from "react"
import Logo from "../../assets/icons/appointment-icon.svg"

const DashboardIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5241 9.75272C20.885 5.81932 17.544 2.89308 13.5607 2.77789C13.3713 2.77047 13.1867 2.83866 13.0477 2.96743C12.9086 3.0962 12.8264 3.27499 12.8193 3.46439V3.46439V3.52846L13.2678 10.2378C13.2972 10.6895 13.6855 11.0328 14.1374 11.0067L20.865 10.5582C21.0546 10.5442 21.2308 10.4552 21.3545 10.3108C21.4782 10.1665 21.5392 9.97882 21.5241 9.78933V9.75272Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.90163 6.76877C9.32959 6.66978 9.76753 6.88875 9.94511 7.29051C9.99163 7.385 10.0196 7.48754 10.0275 7.59257C10.119 8.89234 10.3112 11.739 10.4211 13.2768C10.4398 13.5538 10.5682 13.8119 10.7778 13.994C10.9874 14.1761 11.2609 14.2671 11.5378 14.247V14.247L17.1854 13.8992C17.4375 13.884 17.6847 13.9738 17.8684 14.1471C18.0522 14.3204 18.1561 14.562 18.1556 14.8145V14.8145C17.9268 18.2249 15.4765 21.0759 12.1393 21.815C8.80214 22.554 5.3773 21.0039 3.73001 18.009C3.23826 17.1471 2.92684 16.1941 2.81467 15.2081C2.76672 14.9055 2.74833 14.599 2.75975 14.2928C2.76947 10.6508 5.32726 7.51273 8.89248 6.76877"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const AppointmentIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.09265 9.40445H20.9166"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4421 13.3097H16.4514"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0046 13.3097H12.0139"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.55787 13.3097H7.56714"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4421 17.1964H16.4514"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0046 17.1964H12.0139"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.55787 17.1964H7.56714"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0437 2V5.29078"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.96552 2V5.29078"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2383 3.5791H7.77096C4.83427 3.5791 3 5.21504 3 8.22213V17.2718C3 20.3261 4.83427 21.9999 7.77096 21.9999H16.229C19.175 21.9999 21 20.3545 21 17.3474V8.22213C21.0092 5.21504 19.1842 3.5791 16.2383 3.5791Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const ImagingIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.21 7.89973V16.0497C21.21 19.0697 19.32 21.1997 16.3 21.1997H7.65C4.63 21.1997 2.75 19.0697 2.75 16.0497V7.89973C2.75 4.87973 4.64 2.75073 7.65 2.75073H16.3C19.32 2.75073 21.21 4.87973 21.21 7.89973Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.28131 16.4319L6.81031 14.8189C7.36131 14.2369 8.28631 14.2339 8.84231 14.8109L9.72731 15.7139C10.3243 16.3229 11.3173 16.2789 11.8583 15.6199L14.0873 12.9089C14.7273 12.1299 15.9013 12.0819 16.6023 12.8049L18.6783 14.9469"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3135 9.13413C10.3135 10.1021 9.52752 10.8881 8.55952 10.8881C7.59152 10.8881 6.80652 10.1021 6.80652 9.13413C6.80652 8.16613 7.59152 7.38013 8.55952 7.38013C9.52752 7.38013 10.3135 8.16613 10.3135 9.13413Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const PatientIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9378 3.4375C9.38221 3.4375 7.32951 5.4902 7.32951 8.04575C7.32951 10.602 9.38204 12.6549 11.9378 12.6549C14.4935 12.6549 16.546 10.602 16.546 8.04575C16.546 5.4902 14.4933 3.4375 11.9378 3.4375ZM11.9378 4.9375C13.6649 4.9375 15.046 6.31863 15.046 8.04575C15.046 9.77367 13.665 11.1549 11.9378 11.1549C10.2105 11.1549 8.82951 9.77367 8.82951 8.04575C8.82951 6.31863 10.2106 4.9375 11.9378 4.9375ZM6.28999 4.37937C6.7042 4.37937 7.03999 4.71516 7.03999 5.12937C7.03999 5.54359 6.7042 5.87937 6.28999 5.87937C5.10162 5.87937 4.13782 6.84275 4.13782 8.03062C4.13782 9.2185 5.10162 10.1819 6.28999 10.1819C6.7042 10.1819 7.03999 10.5177 7.03999 10.9319C7.03999 11.3461 6.7042 11.6819 6.28999 11.6819C4.27334 11.6819 2.63782 10.0471 2.63782 8.03062C2.63782 6.01418 4.27334 4.37937 6.28999 4.37937ZM21.247 8.03062C21.247 6.01418 19.6115 4.37937 17.5949 4.37937C17.1807 4.37937 16.8449 4.71516 16.8449 5.12937C16.8449 5.54359 17.1807 5.87937 17.5949 5.87937C18.7832 5.87937 19.747 6.84275 19.747 8.03062C19.747 9.2185 18.7832 10.1819 17.5949 10.1819C17.1807 10.1819 16.8449 10.5177 16.8449 10.9319C16.8449 11.3461 17.1807 11.6819 17.5949 11.6819C19.6115 11.6819 21.247 10.0471 21.247 8.03062ZM20.4958 13.555C20.0156 13.4466 19.5025 13.3725 18.9807 13.3365C18.5675 13.308 18.2094 13.6199 18.1809 14.0331C18.1524 14.4464 18.4642 14.8045 18.8775 14.833C19.324 14.8638 19.7616 14.9269 20.1871 15.0227C20.8488 15.1525 21.2801 15.3678 21.3872 15.5921C21.4677 15.7615 21.4677 15.9606 21.3864 16.132C21.2808 16.3541 20.853 16.5682 20.2007 16.7024C19.795 16.7858 19.5337 17.1823 19.6171 17.5881C19.7006 17.9938 20.0971 18.2551 20.5028 18.1716C21.581 17.9499 22.3708 17.5546 22.7414 16.7756C23.0161 16.1964 23.0161 15.5247 22.7414 14.947C22.3682 14.1651 21.5648 13.7643 20.4958 13.555ZM5.704 14.0331C5.67551 13.6199 5.31741 13.308 4.90418 13.3365C4.38239 13.3725 3.86922 13.4466 3.36845 13.5593L3.162 13.603C2.21438 13.8195 1.49143 14.2174 1.14442 14.9469C0.868561 15.5241 0.868561 16.197 1.14471 16.7762C1.51363 17.5544 2.30341 17.9498 3.38205 18.1716C3.78777 18.2551 4.18431 17.9938 4.26774 17.5881C4.35117 17.1823 4.0899 16.7858 3.68418 16.7024C3.03209 16.5683 2.60472 16.3543 2.49939 16.1321C2.41734 15.96 2.41734 15.7621 2.49838 15.5925C2.60537 15.3676 3.03633 15.1525 3.67721 15.027L4.01044 14.9588C4.34262 14.8974 4.67249 14.8561 5.00738 14.833C5.42062 14.8045 5.7325 14.4464 5.704 14.0331ZM5.16709 17.1845C5.16709 14.7986 7.63503 13.9595 11.9378 13.9595L12.2426 13.961C16.3655 13.9997 18.7084 14.8407 18.7084 17.1671C18.7084 19.4388 16.4689 20.3087 12.5397 20.3863L11.9378 20.3921C7.62516 20.3921 5.16709 19.5678 5.16709 17.1845ZM17.2084 17.1671C17.2084 16.0566 15.4279 15.4595 11.9378 15.4595C8.45105 15.4595 6.66709 16.0661 6.66709 17.1845C6.66709 18.2952 8.44707 18.8921 11.9378 18.8921C15.4234 18.8921 17.2084 18.2851 17.2084 17.1671Z"
        fill="black"
      />
    </svg>
  )
}

const BillingIcon = () => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="C:\Users\Dell\OneDrive\Desktop\the-oet-factory\thepetfactor-vets\src\assets\icons\Wallet.png"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="10.175"
        cy="10.8886"
        r="2.63616"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const SettingsIcon = () => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8067 6.62337L18.1842 5.54328C17.6577 4.62936 16.4907 4.31408 15.5755 4.83847V4.83847C15.1399 5.0951 14.6201 5.16791 14.1307 5.04084C13.6413 4.91378 13.2226 4.59727 12.9668 4.16113C12.8023 3.8839 12.7139 3.56815 12.7105 3.2458V3.2458C12.7254 2.72898 12.5304 2.22816 12.17 1.85743C11.8096 1.48669 11.3145 1.27762 10.7975 1.27783H9.5435C9.03697 1.27783 8.55131 1.47967 8.194 1.8387C7.83669 2.19773 7.63717 2.68435 7.63961 3.19088V3.19088C7.6246 4.23668 6.77248 5.07657 5.72657 5.07646C5.40421 5.07311 5.08846 4.9847 4.81123 4.82017V4.82017C3.89606 4.29577 2.72911 4.61105 2.20254 5.52497L1.53435 6.62337C1.00841 7.53615 1.3194 8.70236 2.23 9.23207V9.23207C2.8219 9.5738 3.18653 10.2053 3.18653 10.8888C3.18653 11.5723 2.8219 12.2038 2.23 12.5456V12.5456C1.32056 13.0717 1.00923 14.2351 1.53435 15.1451V15.1451L2.16593 16.2344C2.41265 16.6795 2.8266 17.0081 3.31619 17.1472C3.80578 17.2863 4.33064 17.2247 4.77462 16.9758V16.9758C5.21108 16.7211 5.73119 16.6513 6.21934 16.782C6.70749 16.9126 7.12324 17.2328 7.37416 17.6714C7.5387 17.9486 7.62711 18.2644 7.63046 18.5868V18.5868C7.63046 19.6433 8.48696 20.4998 9.5435 20.4998H10.7975C11.8505 20.4998 12.7055 19.6489 12.7105 18.5959V18.5959C12.7081 18.0878 12.9089 17.5998 13.2682 17.2405C13.6275 16.8812 14.1155 16.6804 14.6236 16.6829C14.9452 16.6915 15.2596 16.7795 15.5389 16.9392V16.9392C16.4517 17.4651 17.6179 17.1541 18.1476 16.2435V16.2435L18.8067 15.1451C19.0618 14.7073 19.1318 14.1858 19.0012 13.6961C18.8706 13.2065 18.5502 12.7891 18.111 12.5364V12.5364C17.6718 12.2837 17.3514 11.8663 17.2208 11.3767C17.0902 10.8871 17.1603 10.3656 17.4154 9.92772C17.5812 9.63809 17.8214 9.39795 18.111 9.23207V9.23207C19.0161 8.70265 19.3264 7.54325 18.8067 6.63252V6.63252V6.62337Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="10.175"
        cy="10.8886"
        r="2.63616"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const EditIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.64578 8.98467L9.10615 2.61467C9.93734 1.79511 11.2855 1.79511 12.1167 2.61467L12.9796 3.4655C13.8108 4.28506 13.8108 5.61437 12.9796 6.43393L6.49374 12.8291C6.12287 13.1947 5.62005 13.3999 5.09521 13.3999H2.43903C2.19228 13.3999 1.99399 13.1995 2.00014 12.9563L2.06695 10.3136C2.08024 9.81411 2.28751 9.33793 2.64578 8.98467ZM12.3587 4.07769L11.4958 3.22686C11.0075 2.7454 10.2153 2.7454 9.72702 3.22686L9.22549 3.72138L11.8575 6.31599L12.3587 5.82174C12.847 5.34028 12.847 4.55915 12.3587 4.07769ZM3.26665 9.59686L8.60461 4.33357L11.2366 6.92818L5.87286 12.2169L5.80152 12.2813C5.60447 12.4441 5.35481 12.5342 5.09521 12.5342L2.88897 12.5339L2.94472 10.3357C2.95209 10.0584 3.06751 9.79322 3.26665 9.59686ZM14 12.9671C14 12.728 13.8034 12.5342 13.561 12.5342H8.98066L8.92109 12.5382C8.7068 12.5668 8.54164 12.748 8.54164 12.9671C8.54164 13.2062 8.73819 13.4 8.98066 13.4H13.561L13.6205 13.396C13.8348 13.3674 14 13.1863 14 12.9671Z"
        fill="black"
      />
    </svg>
  )
}
const CheckinIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.08171 9.29052L7.08171 1.26318"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.02539 7.33887L7.08139 9.29087L5.13739 7.33887"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.17 4.41846H10.792C12.1487 4.41846 13.248 5.51779 13.248 6.87512L13.248 10.1311C13.248 11.4845 12.1514 12.5811 10.798 12.5811L3.37138 12.5811C2.01471 12.5811 0.914713 11.4811 0.914713 10.1245L0.914713 6.86779C0.914713 5.51512 2.01205 4.41846 3.36471 4.41846H3.99271"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const LabIcon = () => {
  return (
    <svg
      width="15"
      height="24"
      viewBox="0 0 15 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.41494 10.162V7.54726C10.2432 5.06266 10.2159 5.18909 10.2159 5.03036C10.2159 4.31143 9.63099 3.72656 8.91211 3.72656H5.30816C4.58927 3.72656 4.00441 4.31143 4.00441 5.03036C4.00441 5.18894 3.97736 5.06332 4.80523 7.54698V10.1621C1.95008 11.137 0 13.8291 0 16.8902C0 20.8108 3.18961 24.0004 7.11016 24.0004C11.0307 24.0004 14.2203 20.8108 14.2203 16.8902C14.2202 13.829 12.2701 11.1369 9.41494 10.162ZM5.68364 11.3658C6.01247 11.2811 6.22688 10.9773 6.2108 10.651C6.21089 10.6465 6.21146 10.6423 6.21146 10.6379C6.21146 7.15773 6.22533 7.36487 6.17682 7.21566C6.16449 7.17732 6.12314 7.05376 5.48282 5.13279H8.73745C7.9993 7.34706 8.0203 7.25326 8.0112 7.38278C8.00684 7.44254 8.00863 10.6173 8.00942 10.6527C7.99423 10.9785 8.20832 11.2812 8.53659 11.3657C11.5217 12.1341 13.335 15.1278 12.6821 18.1108H7.42596C7.56495 16.7734 6.51268 15.6184 5.18094 15.6184C3.84723 15.6184 2.79708 16.7754 2.93587 18.1108H1.53818C0.886514 15.1337 2.6931 12.1355 5.68364 11.3658ZM4.32991 17.8758C4.32991 17.4065 4.71171 17.0247 5.18094 17.0247C5.65017 17.0247 6.03192 17.4065 6.03192 17.8758C6.03192 18.345 5.65017 18.7268 5.18094 18.7268C4.71171 18.7268 4.32991 18.345 4.32991 17.8758ZM7.11011 22.594C4.91178 22.594 3.00019 21.3438 2.04833 19.5171H3.63376C4.50434 20.3382 5.85703 20.3388 6.72821 19.5171H12.1719C11.22 21.3438 9.30844 22.594 7.11011 22.594Z"
        fill="black"
      />
      <path
        d="M9.32825 16.125C9.74178 16.125 10.0782 15.7885 10.0782 15.375C10.0782 14.9615 9.74178 14.625 9.32825 14.625C8.91472 14.625 8.57825 14.9615 8.57825 15.375C8.57825 15.7885 8.91472 16.125 9.32825 16.125Z"
        fill="black"
      />
      <path
        d="M5.2955 13.6373C5.37266 14.0091 5.72474 14.264 6.12238 14.1895C6.50362 14.1101 6.74723 13.7507 6.67457 13.3626C6.58738 12.9424 6.16715 12.7097 5.78113 12.8273C5.41963 12.9424 5.23002 13.2876 5.2955 13.6373Z"
        fill="black"
      />
      <path
        d="M7.92058 1.63696C7.99938 2.01665 8.3582 2.26209 8.74745 2.18915C9.12868 2.10974 9.37229 1.75035 9.29963 1.36228C9.21385 0.948885 8.8023 0.708885 8.40574 0.826963C8.03435 0.947995 7.85683 1.29632 7.92058 1.63696Z"
        fill="black"
      />
      <path
        d="M4.9205 0.840071C4.99977 1.22206 5.35944 1.46496 5.74738 1.39226C6.13095 1.31234 6.3718 0.951212 6.29956 0.565384C6.21336 0.149978 5.80063 -0.087538 5.40566 0.0300713C5.0398 0.149321 4.85577 0.494181 4.9205 0.840071Z"
        fill="black"
      />
    </svg>
  )
}
const DeleteIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6261 2.26042C10.4349 1.69768 9.9383 1.3335 9.37592 1.3335H6.62395L6.51933 1.33772C5.96613 1.38249 5.49408 1.77947 5.3487 2.33705L5.18362 3.17892L5.16428 3.25302C5.08523 3.49301 4.86424 3.65958 4.61181 3.65958L4.61181 3.65958H2.48759L2.42143 3.66415C2.18344 3.69726 2 3.90646 2 4.1596C2 4.43575 2.2183 4.65962 2.48759 4.65962L4.61181 4.65962H11.3881L13.5124 4.65962L13.5786 4.65505C13.8166 4.62194 14 4.41274 14 4.1596C14 3.88345 13.7817 3.65958 13.5124 3.65958H11.3885C11.3884 3.65958 11.3882 3.65958 11.3881 3.65958L11.3134 3.65468C11.0683 3.62229 10.8658 3.43264 10.8162 3.17872L10.6583 2.36822L10.6261 2.26042ZM9.94289 3.65958C9.92069 3.60313 9.90149 3.54497 9.8855 3.48528L9.85997 3.37488L9.70908 2.59536C9.67381 2.4601 9.5649 2.36108 9.43348 2.33844L9.37592 2.33353H6.62395C6.48714 2.33353 6.36553 2.41565 6.31501 2.51885L6.29788 2.56419L6.13986 3.37508C6.12058 3.47382 6.09266 3.5689 6.057 3.65958H9.94289ZM12.6523 5.81361C12.8983 5.83395 13.0869 6.03827 13.1 6.2842L13.0937 6.42132L12.884 8.98882L12.6641 11.4944C12.6175 11.9946 12.5759 12.4165 12.5399 12.7486C12.415 13.906 11.6637 14.6217 10.5311 14.6429C8.76625 14.6755 7.06985 14.6752 5.42248 14.6395C4.32265 14.6165 3.58244 13.893 3.4597 12.7533L3.37487 11.9136L3.22663 10.2848L3.07477 8.49754L2.90115 6.35208C2.87957 6.07682 3.07967 5.83573 3.3481 5.8136C3.59415 5.79332 3.8122 5.96406 3.86346 6.20468L3.88341 6.40132L4.04644 8.41264L4.22446 10.4974C4.30431 11.3999 4.37356 12.1303 4.42897 12.6434C4.49892 13.2928 4.84092 13.6271 5.44274 13.6397C7.07723 13.6751 8.76099 13.6754 10.5134 13.643C11.1518 13.6311 11.4992 13.3001 11.5707 12.6384L11.6551 11.8032C11.6799 11.5458 11.7063 11.2617 11.7342 10.953L11.9124 8.90269L12.1271 6.27183C12.1469 6.01951 12.3461 5.8261 12.586 5.81271L12.6523 5.81361Z"
        fill="black"
      />
    </svg>
  )
}
const ViewMore = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00016 0.333496C3.31824 0.333496 0.333496 3.31846 0.333496 7.00016C0.333496 10.6819 3.31824 13.6668 7.00016 13.6668C10.6816 13.6668 13.6668 10.6816 13.6668 7.00016C13.6668 3.31869 10.6816 0.333496 7.00016 0.333496ZM7.00016 1.3335C10.1294 1.3335 12.6668 3.87097 12.6668 7.00016C12.6668 10.1294 10.1294 12.6668 7.00016 12.6668C3.87054 12.6668 1.3335 10.1296 1.3335 7.00016C1.3335 3.87073 3.87054 1.3335 7.00016 1.3335ZM3.21516 7.0003C3.21516 7.4403 3.57316 7.7983 4.01383 7.7983C4.4545 7.7983 4.8125 7.4403 4.8125 7.0003C4.8125 6.5603 4.4545 6.20163 4.01383 6.20163C3.57316 6.20163 3.21516 6.5603 3.21516 7.0003ZM7.00016 7.7983C6.5595 7.7983 6.2015 7.4403 6.2015 7.0003C6.2015 6.5603 6.5595 6.20163 7.00016 6.20163C7.44083 6.20163 7.79883 6.5603 7.79883 7.0003C7.79883 7.4403 7.44083 7.7983 7.00016 7.7983ZM9.1875 7.0003C9.1875 7.4403 9.5455 7.7983 9.98616 7.7983C10.4268 7.7983 10.7848 7.4403 10.7848 7.0003C10.7848 6.5603 10.4268 6.20163 9.98616 6.20163C9.5455 6.20163 9.1875 6.5603 9.1875 7.0003Z"
        fill="black"
      />
    </svg>
  )
}
const Profile = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00429 0C5.07027 0 2.69177 2.38864 2.69177 5.33517C2.69177 8.28171 5.07027 10.6703 8.00429 10.6703C10.9383 10.6703 13.3168 8.28171 13.3168 5.33517C13.3168 2.38864 10.9383 0 8.00429 0ZM8.00429 1.44767C10.1422 1.44767 11.8753 3.18816 11.8753 5.33517C11.8753 7.48218 10.1422 9.22268 8.00429 9.22268C5.8664 9.22268 4.1333 7.48218 4.1333 5.33517C4.1333 3.18816 5.8664 1.44767 8.00429 1.44767ZM5.83005 12.8209C5.05233 12.8749 4.26621 12.9859 3.4908 13.1521C1.99418 13.4604 0.796853 14.0763 0.287239 15.0999C0.0950274 15.5002 -0.00161033 15.9288 2.0295e-05 16.3627C-0.000556342 16.7935 0.095299 17.2227 0.280618 17.6153C0.769943 18.6271 1.8278 19.1997 3.25624 19.5171L3.51213 19.5705C4.26648 19.7407 5.05284 19.8553 5.84446 19.909C5.91189 19.9288 6.07258 19.9472 6.24796 19.9561L6.39222 19.9615C6.46639 19.9633 6.55058 19.9637 6.67601 19.9637C7.81385 20.0263 8.99342 20.0081 10.1675 19.9081C10.7932 19.8653 11.4231 19.7835 12.0477 19.6636L12.5151 19.5666C14.0576 19.2623 15.2126 18.6836 15.7186 17.6164C16.0937 16.8241 16.0937 15.9047 15.7188 15.1127C15.214 14.0483 14.0737 13.4744 12.5034 13.1509C11.8873 13.0194 11.2612 12.922 10.6307 12.8599L10.1697 12.8209C8.72593 12.6935 7.27382 12.6935 5.83005 12.8209ZM10.0436 14.263L10.0562 14.264C10.7799 14.3149 11.4991 14.4165 12.2087 14.568C13.3751 14.8083 14.1667 15.2067 14.4171 15.7348C14.6057 16.133 14.6057 16.5958 14.4169 16.9944C14.1829 17.4879 13.472 17.8691 12.4445 18.1021L12.2195 18.1498C11.496 18.3112 10.7791 18.4152 10.0576 18.4647C8.93793 18.5599 7.82495 18.5771 6.71477 18.5171L6.32116 18.5103C6.2119 18.5048 6.11981 18.4942 6.03447 18.4771C5.35872 18.4261 4.75066 18.3454 4.16027 18.2283L3.80775 18.1537C2.63771 17.9244 1.83915 17.5243 1.58024 16.989C1.48964 16.797 1.44125 16.5803 1.44154 16.3609C1.44073 16.1428 1.48848 15.931 1.58118 15.7379C1.83293 15.2324 2.67919 14.7971 3.78606 14.569C4.50073 14.4159 5.21962 14.3144 5.94294 14.264C7.31603 14.143 8.68372 14.143 10.0436 14.263Z"
        fill="black"
      />
    </svg>
  )
}
const Logout = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.33097 0.0214844C11.7102 0.0214844 13.6521 1.89542 13.7611 4.24772L13.766 4.45648V5.38948C13.766 5.8037 13.4302 6.13948 13.016 6.13948C12.6363 6.13948 12.3225 5.85733 12.2728 5.49125L12.266 5.38948V4.45648C12.266 2.89358 11.044 1.61575 9.50341 1.52647L9.33097 1.52148H4.45597C2.89392 1.52148 1.61623 2.74362 1.52696 4.28406L1.52197 4.45648V15.5865C1.52197 17.1493 2.74388 18.4272 4.28363 18.5165L4.45597 18.5215H9.34097C10.8983 18.5215 12.172 17.3039 12.261 15.7693L12.266 15.5975V14.6545C12.266 14.2403 12.6018 13.9045 13.016 13.9045C13.3957 13.9045 13.7095 14.1866 13.7591 14.5527L13.766 14.6545V15.5975C13.766 17.9687 11.8992 19.9046 9.55532 20.0164L9.34097 20.0215H4.45597C2.07753 20.0215 0.135813 18.1474 0.0267998 15.7952L0.0219727 15.5865V4.45648C0.0219727 2.07743 1.89573 0.135347 4.24728 0.0263125L4.45597 0.0214844H9.33097ZM20.3282 9.47968C20.4707 9.6162 20.5595 9.80843 20.5595 10.0214C20.5595 10.2365 20.4689 10.4304 20.3239 10.5672L17.4104 13.4687C17.1169 13.761 16.642 13.76 16.3498 13.4665C16.084 13.1997 16.0607 12.783 16.2791 12.4898L16.3519 12.4059L17.992 10.7714H7.76847C7.35426 10.7714 7.01847 10.4356 7.01847 10.0214C7.01847 9.64169 7.30063 9.32789 7.6667 9.27823L7.76847 9.27138H17.9937L16.352 7.63779C16.0852 7.37212 16.06 6.95551 16.2772 6.66142L16.3497 6.57714C16.6153 6.31028 17.0319 6.28514 17.326 6.50234L17.4103 6.57478L20.3282 9.47968Z"
        fill="black"
      />
    </svg>
  )
}

const EyeIcon = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12C3.5 7 7.5 4 12 4s8.5 3 11 8c-2.5 5-6.5 8-11 8s-8.5-3-11-8zm11-6c-4.33 0-7.88 2.51-10 6 2.12 3.49 5.67 6 10 6 4.33 0 7.88-2.51 10-6-2.12-3.49-5.67-6-10-6zm0 10a4 4 0 110-8 4 4 0 010 8zm0-2a2 2 0 100-4 2 2 0 000 4z"
        fill="black"
      />
    </svg>
  );
};

const UpdateIcon = () => {
  return (
    <svg width="16" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79s7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58 3.51-3.47 9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"
        fill="black"
      />
    </svg>
  );
};

const RebookIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7z" />
      <path d="M16 3v4" />
      <path d="M8 3v4" />
      <path d="M4 11h16" />
      <path d="M10 16h2.5" />
      <path d="M14.5 16h2.5" />
      <path d="M15 14v4" />
    </svg>
  );
};

const AddAppointmentIcon = () => {
  return (
    <svg width="16" height="20" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M460 160h-88v-12A116.13 116.13 0 00258.89 32h-5.78A116.13 116.13 0 00140 148v12H52a4 4 0 00-4 4v300a16 16 0 0016 16h384a16 16 0 0016-16V164a4 4 0 00-4-4zm-280-11c0-41.84 33.41-76.56 75.25-77A76.08 76.08 0 01332 148v12H180zm156 187h-64v64h-48v-64h-64v-48h64v-64h48v64h64z"
        fill="black"
      />
    </svg>
  );
};


const PrintIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
        fill="currentColor"
      />
    </svg>
  );
};

const ArrowDownIcon = () => {
  return (
    <svg
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10l4 4 4-4H8z"
        fill="black"
      />
    </svg>
  );
};



export const IconSVG = ({ icon }) => {
  switch (icon) {
    case "dashboard":
      return <DashboardIcon />
    case "appointment":
      return <AppointmentIcon />
    case "imaging":
      return <ImagingIcon />
    case "labs":
      return <LabIcon />
    case "patient":
      return <PatientIcon />
      case "billings":
      return <BillingIcon />
    case "settings":
      return <SettingsIcon />
    case "edit":
      return <EditIcon />
    case "checkin":
      return <CheckinIcon />
    case "delete":
      return <DeleteIcon />
    case "more":
      return <ViewMore />
    case "profile":
      return <Profile />
    case "logout":
      return <Logout />
    case "view":
      return <EyeIcon />
    case "update":
      return <UpdateIcon />
    case "rebook":
      return <RebookIcon />
    case "print":
      return <PrintIcon />
    case "book-appointment":
      return <AddAppointmentIcon />
    case "arrowDown":
      return <ArrowDownIcon />
    default:

    // code block
  }
}
